import Validator from './validator.js';

export default class MandatoryValidator extends Validator {
    constructor(input) {
        super(input);
        this.type = this.input.el.type;
    }

    valid() {
        if (this.type === 'checkbox') {
            return Promise.resolve(this.input.el.checked);
        }
        return Promise.resolve(this.input.el.value.length > 0);
    }

    static applies(input) {
        return input.el.dataset.mandatory !== undefined;
    }
}
